import { View, ScrollView } from 'react-native'
import { createStyle } from '../../../contexts/global-styles.provider'

/**
 * A card like `meldd.card` but without the native base styles.
 */
export const MelddRawCard = ({
  children,
  action,
  header,
  height,
  width,
}: {
  children: React.ReactNode
  header?: React.ReactNode
  action?: React.ReactNode
  height?: number
  width?: number
}) => {
  const styles = useStyle(height)
  return (
    <View style={[styles.card, width && { width }]}>
      <View style={{ flex: 1, height }}>
        {header && <View style={styles.headerContainer}>{header}</View>}
        <ScrollView
          style={styles.contentScroll}
          contentContainerStyle={styles.contentContainer}
          showsVerticalScrollIndicator={false}
        >
          {children}
        </ScrollView>
        <View style={styles.actionsContainer}>{action}</View>
      </View>
    </View>
  )
}

const useStyle = createStyle(({ theme }, height?: number) => ({
  card: {
    height: height || 320,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    borderRadius: 32,
    backgroundColor: theme.colors.secondaryContainer,
  },

  headerContainer: {
    paddingHorizontal: 16,
    paddingVertical: 8,
  },
  contentScroll: {
    flex: 1,
    backgroundColor: theme.colors.surface,
  },
  contentContainer: {
    flexDirection: 'column',
    paddingHorizontal: 16,
    paddingVertical: 16,
  },
  actionsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 24,
    paddingVertical: 16,
  },
}))
